<template>
    <div id="content-unerlaubt">
        <div>
            <h4>Windsogsicherung durch einen Fachmann nachweisen!</h4>
            <p class="content-absatz"> Achtung! Bei folgenden Angaben müssen Sie die Windsogsicherung <br> durch einen Sonderfachmann nachweisen lassen! </p>
            <div class="d-none d-md-block">
                <p class="content-absatz"> 1. Standorthöhe von über 1.100m </p>
                <p class="content-absatz"> 2. Exponierte Lage </p>
                <p class="content-absatz"> 3. Keine Deckunterlage </p>
                <p class="content-absatz"> 4. Keine geschlossene Deckunterlage + Nicht geschlossenes Gebäude </p>
                <p class="content-absatz"> Sollte eine dieser Angaben zutreffen liegt die Berechnung außerhalb der Möglichkeiten dieses Rechners
                Kontaktieren Sie einen Sonderfachmann. Gerne unterstützen wir Sie hierbei.</p>
            </div>
            <div class="d-block d-md-none">
                <a href="" data-toggle="modal" data-target="#unerlaubtModal">Mehr Informationen</a>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Unerlaubt',
}
</script>

<style scoped>
@media (max-width:991px) {
    p{
    font-size: .8em
    }
    h4{
        font-size: 1em
    }
    .content-absatz
    {
        line-height: 1.3em;
    }
    
    a{
        color: #006FBA;
    }
}
</style>